import { render, staticRenderFns } from "./OverdueReasonStat.vue?vue&type=template&id=740f3b72&scoped=true&"
import script from "./OverdueReasonStat.vue?vue&type=script&lang=ts&"
export * from "./OverdueReasonStat.vue?vue&type=script&lang=ts&"
import style0 from "./OverdueReasonStat.vue?vue&type=style&index=0&id=740f3b72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740f3b72",
  null
  
)

export default component.exports